export function shouldSeeAnnualPlan(currency: string | undefined, variant?: string): boolean {
  if (currency === 'INR') {
    return true;
  }
  return variant === 'variant_b' || variant === 'variant_c';
}
